import { render, staticRenderFns } from "./OrderBuy.vue?vue&type=template&id=a432beea"
import script from "./OrderBuy.vue?vue&type=script&lang=js"
export * from "./OrderBuy.vue?vue&type=script&lang=js"
import style0 from "./OrderBuy.vue?vue&type=style&index=0&id=a432beea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports